import { Link, useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { cartActions } from "../../store/cartSlice";
import { useLocation } from "react-router-dom";

import DUMMY_DATA from "../../dummyData.json";
import classes from "./ProductDetails.module.css";
import { Icon } from "@iconify/react";
import { ButtonPrimary } from "../../components/Button/Button";
import { useState, useEffect } from "react";

const ProductDetails = () => {
  const [addToCart, setAddToCart] = useState(false);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const id = params.productId;
  const productDetail = DUMMY_DATA.filter((val) => val.id === id);

  //使用useLocation 獲取 Link 傳下來的props, 讓上一頁回到原本的page.

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const addtoCartHandler = () => {
    if (!isAuthenticated) {
      alert("請先登入");
      return;
    }
    dispatch(
      cartActions.add({
        id: productDetail[0].id,
        itemName: productDetail[0].itemName,
        img: productDetail[0].img,
        materials: productDetail[0].materials,
        customizable: productDetail[0].cutsomizable,
      })
    );
    setAddToCart(true);
    setTimeout(() => {
      setAddToCart(false);
    }, 5000);
    scrollToTop();
  };

  return (
    <div className={classes.container}>
      <div className={classes.details__header}>
        <div className={classes.details__goback}>
          <Icon
            icon="eva:arrow-ios-back-fill"
            color="#2d3748"
            width="25"
            height="25"
          />
          <Link to={-1}>
            <span>返回</span>
          </Link>
        </div>
        <div className={classes.details__category}>
          <span>商品類別 / </span>
          <span>{productDetail[0].itemName}</span>
        </div>
      </div>
      <div className="main">
        <ul className={classes.productDetails}>
          <li className={classes.details__img}>
            <img src={productDetail[0].img} alt="" />
          </li>
          <div className={classes.details__desc}>
            <li>
              <h4>商品名稱</h4>
              {/* style after fetch real data */}
              {productDetail[0].itemName}
            </li>
            <li>
              <h4>可客製化內容</h4>
              {productDetail[0].customizable}
            </li>
            <li>
              <h4>材質</h4>
              {productDetail[0].materials}
            </li>
            <ButtonPrimary
              className={classes.button}
              onClick={addtoCartHandler}
              background={`${
                addToCart ? "var(--gray-800)" : "var(--gray-300)"
              }`}
              text={`${addToCart ? "加入成功 ✅" : "加入詢價單"}`}
            />
          </div>
        </ul>
      </div>
    </div>
  );
};

export default ProductDetails;
